import { Text, Layout } from '@loadsmart/miranda-react'

import { type Contact } from '../../../shipments/domain/Facility'
import { formatPhoneNumber } from '../../../shipments/presenters/phoneNumberPresenter'

export function FacilityContactInformation({
  facilityContact,
}: {
  facilityContact?: Partial<Contact>
}) {
  return (
    <Layout.Stack style={{ marginTop: '16px' }} gap="spacing-2">
      <Text variant="body-md" color="color-text-tertiary">
        Facility contact
      </Text>
      <Layout.Stack gap="spacing-1">
        {facilityContact ? (
          <Layout.Stack gap="spacing-0-5">
            <Text variant="body-md" color="color-text-primary">
              {facilityContact.name || 'No name information available.'}
            </Text>
            <Text variant="body-md" color="color-text-primary">
              {formatPhoneNumber(facilityContact)}
            </Text>
            <Text variant="body-md" color="color-text-primary">
              {facilityContact.email || 'No email information available.'}
            </Text>
          </Layout.Stack>
        ) : (
          <Text variant="body-md" color="color-text-primary">
            No contact information available.
          </Text>
        )}
      </Layout.Stack>
    </Layout.Stack>
  )
}
